// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1A-k9","boxTitle":"Qualiphy_boxTitle__3-AFq","box":"Qualiphy_box__3gi-w","toggleWrap":"Qualiphy_toggleWrap__2zT5s"};